import { ColoredTextFindReplaceItem, NamedColorList } from 'src/app/domainObjects/coloredTextItem';
import { ColumnLookupRule, ConditionEndType, ConditionStartType } from 'src/app/domainObjects/transformers/columnLookupTransform';
import { TransformRuleViewModel } from 'src/app/viewModels/transformRuleViewModel';
import { __values } from 'tslib';

export class ColumnLookupRuleViewModel extends TransformRuleViewModel {
    rule: ColumnLookupRule;
    targetDataType: string;	
    keyField: string;	
    lookupField: string;	
    conditionStart: ConditionStartType;	
    keyParams: string;	
    conditionEnd: ConditionEndType;	
    lookupParams: string;	
    sourceField: string;
    targetField: string;
    ifNoMatch: string;	
    mergeHits?: number;
    lookupHits?: number;

    conditionStartPre: ConditionStartType;	
    keyParamsPre: string;	
    conditionEndPre: ConditionEndType;	
    lookupParamsPre: string;	

    conditionStartFrom: ConditionStartType;
    conditionEndFrom: ConditionEndType;	
    findReplaceList?: ColoredTextFindReplaceItem[];
    matchCase: boolean;
    matchAll: boolean;

    constructor(rule: ColumnLookupRule) {
      super(rule.ruleId, rule.index, rule.run, rule.ruleName);

      this.sourceField = rule.sourceField;
      this.targetField = rule.targetField;
      this.targetDataType = rule.targetDataType;
      this.keyField = rule.keyField;
      this.lookupField = rule.lookupField;
      this.conditionStart = rule.conditionStart;
      this.keyParams = rule.keyParams.toString();
      this.conditionEnd = rule.conditionEnd;
      this.lookupParams = rule.lookupParams.toString();
      this.findReplaceList = rule.findReplace 
        ? Object.entries(rule.findReplace).map(([find, replace], index) => {
            // Reset or cycle through the NamedColorList array with colorIndex modulo NamedColorList length
            const color = NamedColorList[index % NamedColorList.length];
            return new ColoredTextFindReplaceItem(find, replace, color);
          })
        : [];
      if(!rule.ifNoMatch){
        this.ifNoMatch ="None";
      }else{
        this.ifNoMatch = rule.ifNoMatch;
      }
      this.matchCase = rule.matchCase;
      this.matchAll = rule.matchAll;
      this.run = rule.run;


      this.conditionStartPre = rule.conditionStart;
      this.keyParamsPre = rule.keyParams.toString();
      this.conditionEndPre = rule.conditionEnd;
      this.lookupParamsPre = rule.lookupParams.toString();

      this.conditionStartFrom = rule.conditionStart;
      this.conditionEndFrom = rule.conditionEnd;
    }

    toRule(): ColumnLookupRule {
      const rule = new ColumnLookupRule();

      rule.index = this.index - 1;
      rule.ruleName = this.name;
      rule.keyField = this.keyField;
      rule.lookupField = this.lookupField;
      rule.conditionStart = this.conditionStart;
      rule.keyParams = this.keyParams.split(",");
      rule.conditionEnd = this.conditionEnd;
      rule.lookupParams = this.lookupParams.split(",");
      rule.sourceField = this.sourceField;
      rule.targetField = this.targetField;
      if(this.findReplaceList.length===0){
        rule.findReplace=undefined;
      }else{
        rule.findReplace={};
        this.findReplaceList.forEach(item => {
          rule.findReplace[item.find] = item.replace;
        });
      }
      rule.matchAll = this.matchAll;
      if(this.ifNoMatch=="None"){
        rule.ifNoMatch = undefined;
      }else{
        rule.ifNoMatch = this.ifNoMatch;
      }
      rule.matchCase = this.matchCase;
      rule.run = this.run;
      
      return rule;
    }
}
